import { AppPlatformService } from 'src/app/service/platform/app-platform.service';

export type EmbedTransport = 'in-page' | 'bridge';

/**
 * One place decides the transport, the same style as `item-player.policy.ts`'s `playerSlot()`.
 *
 * The native app (`AppPlatformService.isAppPlatform()`) always goes through the bridge: inside
 * Capacitor the origin is `capacitor://localhost`, which YouTube rejects outright and which Vimeo
 * never worked from either (see the plan's production findings table). Everywhere else — web, mobile
 * web, and the bridge page mounting itself (`isInIframe()` makes `isAppPlatform()` false there too,
 * so it never recurses into mounting another bridge) — the SDK runs in-page.
 */
export function embedTransport(appPlatform: AppPlatformService): EmbedTransport {
  return appPlatform.isAppPlatform() ? 'bridge' : 'in-page';
}
